function createRepeatedImage(data) {
  var qFactor = data.qFactor;
  var gui = data.gui;
  var repeats = data.repeats;
  var isPattern = data.isPattern;
  var naturalWidth = data.naturalWidth;
  var naturalHeight = data.naturalHeight;
  var imageMimeType = data.mime;

  function getImage(image) {
    return new Promise((resolve) => {
      var width = naturalWidth * repeats;
      var height = naturalHeight * (isPattern ? repeats : 1);
      var canvas = new OffscreenCanvas(width, height);
      var ctx = canvas.getContext("2d");

      if (isPattern) {
        for (let x = 0; x < repeats; x++) {
          for (let y = 0; y < repeats; y++) {
            ctx.drawImage(image, x * naturalWidth, y * naturalHeight, naturalWidth, naturalHeight);
          }
        }
      } else {
        for (let x = 0; x < repeats; x++) {
          ctx.drawImage(image, x * naturalWidth, 0, naturalWidth, naturalHeight);
        }
      }

      canvas.convertToBlob({ type: imageMimeType, quality: qFactor }).then(resolve);
    });
  }

  return createImageBitmap(gui).then(getImage);
}

module.exports = createRepeatedImage;
